import React, { FC, ReactElement } from 'react';

import * as S from './styles';

type CardProps = {
  children: ReactElement;
};

export const Card: FC<CardProps> = (props) => {
  const { children } = props;

  return <S.CardWrapper>{children}</S.CardWrapper>;
};
